import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Star, MapPin } from "lucide-react";
import api from "../../lib/api";

export const relativeDate = (iso) => {
  const days = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));
  if (days === 0) return "today";
  if (days < 7) return `${days} day${days > 1 ? "s" : ""} ago`;
  if (days < 30) { const w = Math.floor(days / 7); return `${w} week${w > 1 ? "s" : ""} ago`; }
  const m = Math.floor(days / 30);
  return `${m} month${m > 1 ? "s" : ""} ago`;
};

const Stars = ({ n }) => (
  <span className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`w-3.5 h-3.5 ${i <= n ? "text-[#fbbc04] fill-[#fbbc04]" : "text-gray-300"}`} />
    ))}
  </span>
);

export const ReviewsCarousel = () => {
  const { t } = useTranslation();
  const [reviews, setReviews] = useState([]);
  const [start, setStart] = useState(0);

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (reviews.length <= 3) return;
    const t = setInterval(() => setStart((s) => (s + 1) % reviews.length), 5000);
    return () => clearInterval(t);
  }, [reviews.length]);

  if (reviews.length === 0) return null;
  const shown = [0, 1, 2].map((i) => reviews[(start + i) % reviews.length]).filter(Boolean);

  return (
    <section className="bg-white" data-testid="reviews-carousel">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="promo-stripe mb-2">
          <h2 className="heading-upper text-xl text-[#144733]">{t("Rated by real drivers")}</h2>
        </div>
        <p className="text-sm text-[#57685e] mb-6 flex items-center gap-2">
          <span className="font-bold text-lg" style={{ fontFamily: "arial" }}>
            <span className="text-[#4285F4]">G</span><span className="text-[#EA4335]">o</span><span className="text-[#FBBC05]">o</span><span className="text-[#4285F4]">g</span><span className="text-[#34A853]">l</span><span className="text-[#EA4335]">e</span>
          </span>
          {t("reviews from Europcar UAE customers")}
        </p>
        <div className="grid sm:grid-cols-3 gap-4">
          {shown.map((r) => (
            <div key={r.review_id} className="bg-[#fafcfa] border border-[#e2ebe4] rounded-2xl p-5 flex flex-col" data-testid={`review-card-${r.review_id}`}>
              <div className="flex items-center justify-between">
                <Stars n={r.rating} />
                <span className="text-[10px] text-[#8a978f]">{relativeDate(r.review_date)}</span>
              </div>
              <p className="text-sm text-[#41504a] leading-relaxed mt-3 flex-1">“{r.text}”</p>
              <div className="mt-4 pt-3 border-t border-dashed border-[#e2ebe4]">
                <div className="text-sm font-bold text-[#0F1E17]">{r.name}</div>
                <div className="text-[11px] text-[#57685e]">{r.context}</div>
                <div className="text-[10px] text-[#8a978f] flex items-center gap-1 mt-0.5"><MapPin className="w-3 h-3" /> {r.branch}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
